import { DeviceDTO } from '@eppendorf/vnls-device-service-utils';
import { Dialog, HasClassName, Icon } from '@eppendorf/vnls-react-components';

import { DeviceNameOrSerialNumber } from '$components/device/device-name-or-serialnumber/device-name-or-serialnumber';
import { useDeviceViewConfig } from '$features/devices/devices.view.config';

export interface DeviceDetailHeaderProps extends HasClassName {
  device?: DeviceDTO;
}

export function DeviceDetailHeader({ className, device }: DeviceDetailHeaderProps) {
  const viewConfig = useDeviceViewConfig(device);

  return (
    <div className={`device-detail-header ${className}`}>
      <Icon name={viewConfig.deviceIcon} />
      <div className="device-detail-header__text">
        <Dialog.Title className="device-detail-header__name">
          <DeviceNameOrSerialNumber device={device} />
        </Dialog.Title>
        <div className="device-detail-header__model">
          {device?.manufacturer} {device?.model}
        </div>
      </div>
    </div>
  );
}
